import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './plugins/i18n';
import { Analytics } from './analytics.js';
import wb from "./registerServiceWorker";
import FlagIcon from 'vue-flag-icon';
import $ from 'jquery';

window.$ = window.jQuery = $;
window.pageAlreadyLoaded = false; // Set this to true when App.vue mounts. This way, we can run focusPageHeading when any individual component mounts WITHOUT also doing so when someone loads the site up for the first time, or manually refreshes.

window.getPageHeading = (selector) => {
	return document.querySelector(selector ? selector : "h1, [role='heading'][aria-level='1']");
}

window.focusPageHeading = (selector) => {
	let heading = getPageHeading(selector);
	if(heading && window.pageAlreadyLoaded) {
		heading.setAttribute("tabindex","-1");
		heading.focus();
	}
}

window.setPageTitle = (translatableString) => {
	try {
		let baseTitle = `${ar.i18nJ.t('remoteHeader')}`;
		document.title = translatableString ? `${ar.i18nJ.t(translatableString)} - ${baseTitle}` : baseTitle;
	} catch {
		// Quiet error
	}
}

window.addEventListener("focusin", (e) => {
	if(e.relatedTarget) {
		if(ar.state.menuOpen && e.relatedTarget.closest("#menu") && !e.target.closest("#menu")) {
			document.getElementById("menu_btn").focus(); // Hack fix for Safari that prevents tabbing outside the menu if if "Press Tab to highlight each item on a webpage" is turned off.
		}
	}
});


// Analytics / Consent -- EARLY!
if ( window.arff.analyticsEnabled ) {
	const consentMode = ar.getLocal('consentMode');
	if ( consentMode === null ) {
		// If there are no stored consent settings, set defaults to denied across the board
		Analytics.setConsentSettings(false, {
			ad_storage: 'denied',
			analytics_storage: 'denied',
			personalization_storage: 'denied',
			functionality_storage: 'denied',
			security_storage: 'denied'
		});
	} else {
		// Apply stored consent settings, assuming they parse correctly
		try {
			Analytics.setConsentSettings(false, JSON.parse(consentMode));
		} catch (ex ) {
			console.log('analytics: consent: failed to parse consentMode from localStorage');
		}
	}
}


Vue.prototype.$workbox = wb;
Vue.use(FlagIcon);
Vue.config.productionTip = false;

// "Global" VueJSS viewmodel object
// Keep access to it for hackery
ar.vm = new Vue({
	router,
	i18n,
	render(h) { return h(App); },
}).$mount('#arApp');